import React from 'react';
import { CheckCircleIcon, StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { tomos } from '../constants/data';
export function Tomos() {
  return <section className="w-full px-5 py-16 sm:py-24" style={{
    backgroundColor: '#0A0A0A'
  }} data-id="element-245">
      <div className="mx-auto max-w-5xl" data-id="element-246">
        <Reveal data-id="element-247">
          <h2 className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold" data-id="element-248">
            📦 Los 6 Tomos Completos
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-249">
          {tomos.map((tomo, i) => <Reveal key={tomo.number} delay={i % 2 * 0.1} data-id="element-250">
              <article className="glass glass-hover h-full p-6 border-l-4" style={{
            borderLeftColor: tomo.color
          }} data-id="element-251">
                <div className="flex items-center gap-2" data-id="element-252">
                  <span className="text-sm font-bold" style={{
                color: tomo.color
              }} data-id="element-253">
                    TOMO {tomo.number}
                  </span>
                  {tomo.star && <StarIcon className="w-4 h-4 fill-current" style={{
                color: '#FFD700'
              }} aria-hidden="true" data-id="element-254" />}
                </div>
                <h3 className="mt-1 text-lg font-bold text-white" data-id="element-255">
                  {tomo.name}
                </h3>
                <p className="mt-1 text-sm italic text-white/50" data-id="element-256">
                  {tomo.subtitle}
                </p>

                <ul className="mt-4 space-y-2" data-id="element-257">
                  {tomo.points.map(p => <li key={p} className="flex gap-2 text-sm text-white/80" data-id="element-258">
                      <span className="font-bold" style={{
                  color: '#00C853'
                }} data-id="element-259">
                        ·
                      </span>
                      {p}
                    </li>)}
                </ul>

                <div className="mt-5 inline-flex items-center gap-2 rounded-lg px-3 py-2 text-xs sm:text-sm font-medium" style={{
              backgroundColor: 'rgba(0,200,83,0.12)',
              color: '#5CE08C'
            }} data-id="element-260">
                  <CheckCircleIcon className="w-4 h-4 shrink-0" aria-hidden="true" data-id="element-261" />
                  Resultado: {tomo.result}
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}